<template>
    <div>
        <le-pagview @setData="setTableData" :pageParam="pageParam" v-if="pageParam" style="margin-top: 0px !important;">
            <el-table :data="tableData" :highlight-current-row="true" max-height="510" class="zdxx-table">
                <el-table-column prop="startDate" label="开始日期">
                </el-table-column>
                <el-table-column prop="endDate" label="结束日期">
                </el-table-column>
                <el-table-column prop="startTimeText" label="附件">
                    <template slot-scope="{ row }">
                        <el-link type="primary" :underline='false' @click="handlePreviewFile(row)">{{ row.contractFile }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="endTimeText" label="合同说明">
                    <template slot-scope="{ row }">
                        <span>{{ row.contractNote || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="stateText" label="操作人">
                    <template slot-scope="{ row }">
                        <span>{{ row.operateName || '-' }} {{ row.operatePhone || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="operateTime" label="操作时间">
                </el-table-column>
                <el-table-column label="操作" fixed="right" width='70'>
                    <template slot-scope="{ row }">
                        <el-tooltip class="item" effect="dark" content="编辑合同" placement="top" >
                            <img src="../../assets/icon/option-edit.png" class="a-wh-16" @click="handleEdit(row)"/>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除合同" placement="top" >
                            <img src="../../assets/icon/option-refuse.png" class="a-wh-16 a-ml-16" @click="handleDel(row)"/>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </le-pagview>
        <upload-contract-file ref="uploadContractFile" :defaultData='currentRow' type='update' @success='handleUploadContractFileSuccess'></upload-contract-file>
    </div>
	
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';
    import UploadContractFile from './child/uploadContractFile.vue';
	export default {
        components: {
            UploadContractFile
        },
		props: {
			incomeId: {
				type: Number,
			},
		},
		computed: {
			...mapState({
				company: state => state.company.company,
			})
		},
		data() {
			return {
				pageParam: '',
                currentRow: '',
				tableData: []
			}
		},
		watch: {
			incomeId: {
				handler(val) {
					if (val) {
						this.pageParam = {
							url: this.$Config.apiUrl.incomeContractList,
							method: "get",
							params: {
								incomeId: this.incomeId
							},
							freshCtrl: 1,
						}
					}
				},
				immediate: true
			},

		},
		methods: {
			setTableData(data) {
				this.tableData = data.data
			},
            handleEdit (datas) {
                this.currentRow = datas
                this.$refs['uploadContractFile'].id = datas.id
                this.$refs['uploadContractFile'].incomeId = this.incomeId
                this.$refs['uploadContractFile'].dialogVisible = true
            },
            handleUploadContractFileSuccess () {
                this.pageParam.freshCtrl++
            },
            refresh () {
                this.pageParam.freshCtrl++
            },
            handleDel (datas) {
                this.$confirm('是否确认删除该物业合同', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$Axios._get({
						url: this.$Config.apiUrl.incomeContractDelete,
						params: {
							id: datas.id,
						},
					})
					.then(({
						data
					}) => {
						this.pageParam.freshCtrl++
					});
				}).catch(() => {

				})
            },
            handlePreviewFile (row) {
                if(row.contractFile) {
                    window.open(row.contractFile, '_blank')
                }else {
                    this.$message.warning('暂无可预览文件')
                }
            }
		}
	}
</script>

<style>
</style>
